<template>
    <div v-if="isAdmin" class="card text-center">
        <a :href="'status/create/' + PlaceId">
            <div class="card-header">
                <span :class="'icon-place-' + PlaceId"></span>
            </div>
            <div class="card-body d-flex justify-content-center">
                <span
                    class="h3 wf-kosugimaru nl2br"
                    :class="{
                        'text-secondary': isGray,
                        'text-danger': isRed,
                        'text-success': isGreen,
                    }"
                    >{{ Status }}</span
                >
            </div>
            <div class="card-footer">{{ Name }}</div>
        </a>
    </div>
    <div v-else class="card text-center">
        <a :href="'https://www.park-funabashi.or.jp/and/kodomo/atelier.php?atelier=' + PlaceId">
            <div class="card-header">
                <span :class="'icon-place-' + PlaceId"></span>
            </div>
            <div class="card-body d-flex justify-content-center">
                <span
                    class="h3 wf-kosugimaru nl2br"
                    :class="{
                        'text-secondary': isGray,
                        'text-danger': isRed,
                        'text-success': isGreen,
                    }"
                    >{{ Status }}</span
                >
            </div>
            <div class="card-footer">{{ Name }}</div>
        </a>
    </div>
</template>

<script>
export default {
    name: 'Status',
    props: {
        status: {
            type: Object,
            required: true,
        },
        isAdmin: Boolean,
    },
    data() {
        return {
            isGray: false,
            isRed: false,
            isGreen: false,
        }
    },
    computed: {
        Status() {
            let status = this.status.status
            // if (this.status.is_waiting) status = '次は13:00〜'
            // if (this.status.is_closed) status = '受付終了'
            this.color(status)
            return status
        },
        PlaceId() {
            return this.status.place.id
        },
        Name() {
            return this.status.place.name
        },
    },
    methods: {
        color(status) {
            this.isGray = this.isRed = this.isGreen = false
            switch (status) {
                case '受付終了':
                case '次は13:00〜':
                    this.isGray = true
                    break
                case '満席':
                case '休止中':
                case '土日祝のみ':
                    this.isRed = true
                    break
                default:
                    this.isGreen = true
                    break
            }
        },
    },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Kosugi+Maru&display=swap');
.wf-kosugimaru {
    font-family: 'Kosugi Maru', sans-serif;
    margin-bottom: 0;
}
.nl2br {
    white-space: pre-line;
    word-wrap: break-word;
}
a:link,
a:visited,
a:hover,
a:active {
    text-decoration: none;
    color: black;
}
</style>
